import React, { useState } from "react";
import { Container, Divider, InputContain, Span } from "../GodMode"; 
import InputBox from "../../Generic/InputBox";
import Button from "../../Generic/Button";
import { errorNotification } from "../../Generic/Notifications";

const MircowaveTasks = {
	"MICROWAVE_SHUTTER_UP": "MICROWAVE_SHUTTER_UP",
	"MICROWAVE_SHUTTER_DOWN": "MICROWAVE_SHUTTER_DOWN",
	"MICROWAVE_HEAT": "MICROWAVE_HEAT",
}

const MICROWAVE_TASKS_CONFIG = {
	[MircowaveTasks.MICROWAVE_SHUTTER_UP]: { 
		taskType: "microwave_shutter_up", 
		name: "Move Microwave Shutter Up" 
	},
	[MircowaveTasks.MICROWAVE_SHUTTER_DOWN]: { 
		taskType: "microwave_shutter_down", 
		name: "Move Microwave Shutter Down" 
	},
	[MircowaveTasks.MICROWAVE_HEAT]: { 
		taskType: "microwave_heat", 
		name: "Start Microwave Heating" 
	},
}

const Mircowave = ({ sendTask, loadingStates }) => {
	const [heatingDuration, setHeatingDuration] = useState(0);
	const [exhaustFanSpeed, setExhaustFanSpeed] = useState(0);
	const isShutterUpLoading = loadingStates[MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_SHUTTER_UP].taskType] || false;
	const isShutterDownLoading = loadingStates[MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_SHUTTER_DOWN].taskType] || false;
	const isHeatLoading = loadingStates[MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_HEAT].taskType] || false;

	const handleShutterUp = async () => {
		await sendTask(MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_SHUTTER_UP], {});
	};

	const handleShutterDown = async () => {
		await sendTask(MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_SHUTTER_DOWN], {});
	};

	const handleMicrowaveHeat = async () => {
		if(!heatingDuration) {
			errorNotification('No heating duration provided')
			return;
		}
		await sendTask(MICROWAVE_TASKS_CONFIG[MircowaveTasks.MICROWAVE_HEAT], { microwave_heat_time: heatingDuration, customExhaustFanSpeed: exhaustFanSpeed });
	}

	return (
		<>
			<Container>
				<Button onClick={handleShutterUp} disabled={isShutterUpLoading}>
					Microwave Shutter Up
				</Button>
				<Button onClick={handleShutterDown} disabled={isShutterDownLoading}>
					Microwave Shutter Down
				</Button>
			</Container>
			<Divider />
			<Container>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						Microwave Heat Time (s)
					</Span>
					<InputBox onChange={(e) => { setHeatingDuration(e.target.valueAsNumber) }} type="number" required />
				</InputContain>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						Microwave Exhaust Fan Speed
					</Span>
					<InputBox defaultValue={exhaustFanSpeed} onChange={(e) => { setExhaustFanSpeed(e.target.valueAsNumber) }} type="number" required />
				</InputContain>
				<Button onClick={handleMicrowaveHeat} disabled={isHeatLoading}>
					Microwave Heat
				</Button>
			</Container>
		</>
	);
};

export default Mircowave;
